import React from 'react';
import { CalculatorSection } from './../Calculators/Sections';
import { TextInput, RangerInput } from './../Form/index';
import { ErrorBox } from './Sidebar';
import { config } from './../../config/config';
import { toPct } from './../../services/Formats';

export const StopIcon = () => (
  <svg viewBox="0 0 512 512" style={{ width: 32, height: 32 }}>
    <path
      fill="#ff0000"
      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
    />
  </svg>
);

export const ClientLoan = ({ input, output, onChangeInput }) => (
  <CalculatorSection className="section-loan" >
    <div className="title">Loan information</div>

    {/*<div className="section-row">*/}
    {/*  <div className="column-icon clr1">*/}
    {/*    <img src="images/icon-people.png" />*/}
    {/*  </div>*/}

    {/*  <div className="pad column-cell">*/}
    {/*    <div>*/}
    {/*        <div className="label">Client age</div>*/}
    {/*        <div className="sub" style={{ fontSize: '0.6rem' }}>*/}
    {/*          (youngest if in couple)*/}
    {/*        </div>*/}
    {/*    </div>*/}

    {/*    <div style={{ marginLeft:16, marginRight: 16 }}>*/}
    {/*      <RangerInput*/}
    {/*        className="ranger"*/}
    {/*        value={input.clientAge} min={55} max={84} withLabel={true}*/}
    {/*        color={config.main} inactiveColor='#bbbbbb'*/}
    {/*        onChange={val => { onChangeInput('clientAge', val) }}*/}
    {/*      />*/}
    {/*    </div>*/}

    {/*  </div>*/}

    {/*</div>*/}
    {/*{(input.clientAge < 55 || input.clientAge > 84) ? (*/}
    {/*  <div className="section-row clr1">*/}
    {/*    <div style={{ marginLeft: 20, marginRight: 20, width: '100%' }}>*/}
    {/*      <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>*/}
    {/*        Please enter client age between 55 and 85*/}
    {/*      </ErrorBox>*/}
    {/*    </div>*/}
    {/*  </div>*/}
    {/*): false}*/}

    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-pounds.png" />
      </div>

      <div className="pad column-cell">
        <div className="label">Loan amount</div>
        <div style={{ marginRight: 16 }}>
          <TextInput
            width={150} style={{ textAlign: 'right' }}
            type="currency" prefixes="&pound;"  value={input.loanTaken} onChange={val => { onChangeInput('loanTaken', parseFloat(val, 10)) }} />
          {/*(input.loanTaken > output.ltv.max) ? (<div style={{ paddingTop: 60 }}><StopIcon /></div>) : false*/}
        </div>
      </div>
    </div>

    {(input.loanTaken > output.ltv.max) ? (
      <div className="section-row">
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            The loan amount entered is higher than the amount your client could borrow, please enter an amount up to
            £{output.ltv.max}
          </ErrorBox>
        </div>
      </div>
    ): false}

    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-house-pounds.png" />
      </div>
      <div className="pad column-cell">
        <div className="label">Property value</div>
        <div style={{ marginRight: 16 }}>
          <TextInput
            width={150} style={{ textAlign: 'right' }}
            type="currency" prefixes="&pound;" value={input.housePrice} onChange={val => { onChangeInput('housePrice', val) }}
          />
        </div>
      </div>
    </div>

    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-pct.png" />
      </div>

      <div className="pad column-cell">
        <div>
          <div  className="label">Loan MER (%) &nbsp; &nbsp; </div>
          <div className="sub" style={{ fontSize: '0.6rem' }}>
            Loan MER varies from a minimum 2.25 to a maximum of 8%
          </div>
        </div>
        <div style={{ marginLeft:16, marginRight: 16 }}>
          <TextInput
            id={'interestTaken'}
            width={150}
            style={{ textAlign: 'right', width: 120 }}
            type="text"
            prefixes="%"
            value={input.interestTaken}
            min={2.25}
            max={8}
            step={0.05}
            onChange={val => {
              let formattedString = val.replace(/[^0-9^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^0+/, '');
              let rounded = parseFloat(formattedString).toFixed(2);

              let decimalLength = 0;

              if(formattedString.split('.')[1] != undefined)
              {
                decimalLength = formattedString.split('.')[1].length;
              }

              if(decimalLength > 2)
              {
                setTimeout(function() {
                  document.getElementById("interestTaken").value = rounded;
                },100);
              }

              // if(rounded > 8)
              // {
              //   rounded = 8.00;
              //
              //   setTimeout(function() {
              //     document.getElementById("interestTaken").value = 8;
              //   },100);
              // }
              //
              // if(rounded < 2.25)
              // {
              //   rounded = 2.25;
              //
              //   setTimeout(function() {
              //     document.getElementById("interestTaken").value = 2.25;
              //   },100);
              // }

              onChangeInput('interestTaken', rounded)
            }}
          />
        </div>
      </div>
    </div>
    {(input.interestTaken < 2.25 || input.interestTaken > 8) ? (
      <div className="section-row">
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            The MER is outside the allowed range
          </ErrorBox>
        </div>
      </div>
    ): false}
  </CalculatorSection>
);



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/ClientLoan.js